import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject     } from 'rxjs';
import { map, repeat, switchMap, tap } from 'rxjs/operators';

import { CountersService, QueryCollectorService, SidebarStorageService } from '@shared/services';
import { ContractExtensionsCountersModel } from '@shared/models';

@Injectable()
export class ContractExtensionsCountersService {
  private static COUNTERS_API: string = 'api/portal/v3/contract_extensions_counters';
  private reloadCounter$ = new Subject<void>();
  private skipUpdate: boolean;

  constructor(
    private http:                  HttpClient,
    private sidebarStorageService: SidebarStorageService,
    private countersService:       CountersService,
    private queryCollectorService: QueryCollectorService,
  ) { }

  get Counters(): Observable<ContractExtensionsCountersModel> {
    return this.requestCounters().pipe(
      repeat({delay: () => this.reloadCounter$})
    );
  }

  reloadCounters(skipUpdate: boolean = null): void {
    this.skipUpdate = skipUpdate;
    this.reloadCounter$.next();
  }

  private requestCounters(): Observable<ContractExtensionsCountersModel> {
    return of(ContractExtensionsCountersService.COUNTERS_API).pipe(
      map(url => url + this.queryCollectorService.getCountersQuery()),
      switchMap(url => this.http.get<ContractExtensionsCountersModel>(url)),
      tap(({active}) => {
        this.sidebarStorageService.changeContractExtensionsCount(active.length);
        this.countersService.checkForUpdates({active}, 'contract-ext', this.skipUpdate);
        this.skipUpdate = null;
      })
    );
  }

}
